import React from "react";
import { Download } from "lucide-react";
import DataQuality from "./DataQuality";

const DataQualityPage = () => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="px-6 py-3">
          {/* Title Section */}
          <div className="flex items-center justify-between mb-0">
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                Data Intelligence Hub
              </h1>
              <p className="text-gray-500 text-xs mt-1">
                Data quality, forecasting & privacy management
              </p>
            </div>
            <button className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:shadow-lg transition-all font-medium text-sm">
              <Download className="w-3 h-3" />
              Export
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <DataQuality />
        </div>
      </main>
    </div>
  );
};

export default DataQualityPage;

